import { CLASSES } from "@/scripts/helpers/constants";
import Cookies from "js-cookie";

export default () => {
  const alternativeDrift = $(".alternative-drift-frame"),
        driftChat = $(".drift-frame-controller"),
        driftMassage = $(".drift-frame-massage"),
        driftMassageClose = $(".drift-frame-massage__popup-close"),
        $body = $("body");

  const checkDrift = () => {
    if (alternativeDrift.length) {
      $body.addClass("drift-custom-body");
      driftChat.addClass("drift-custom-class");

      const driftRefresh = Cookies.get("drift_campaign_refresh");

      if(driftRefresh){
        Cookies.remove('drift_campaign_refresh');
      }
    }
  }

  checkDrift();

  const hiddenDriftMassage = () => {
    driftMassage.addClass(CLASSES.IS_HIDDEN);

    Cookies.set('drift-massage-hidden', 'true');
  };

  if (driftChat.length) {
    alternativeDrift.addClass(CLASSES.IS_VISIBLE);

    const driftMassageHidden = Cookies.get("drift-massage-hidden");

    if(!driftMassageHidden){
      driftMassage.addClass(CLASSES.IS_VISIBLE);
    }
    
    driftMassageClose.click(function(e) {
      hiddenDriftMassage();
    });

    setTimeout(() => {
      hiddenDriftMassage();
    }, 240000);
    
  }
}
